import StateStepper from '@/components/StateStepper/StateStepper';
import * as OM from '@/messages/order';

export type ReturnOrderStatusStepperProps = {
  status: FulfillmentStatus;
};

export type FulfillmentStatus =
  | 'IN_RETURN'
  | 'RETURN_REGISTERED'
  | 'RETURN_RECEIVED'
  | 'RETURN_ACCEPTED'
  | 'RETURN_REJECTED'
  | 'RETURN_CANCELLED'
  | 'PARTIALLY_RETURNED'
  | 'REFUNDED';

export const RETURN_ORDER_STATUS_MESSAGE_MAPPING: Partial<
  Record<FulfillmentStatus, JSX.Element>
> = {
  IN_RETURN: OM.InReturnOrderStatus,
  RETURN_REGISTERED: OM.ReturnRegisteredOrderStatus,
  RETURN_RECEIVED: OM.ReturnReceivedOrderStatus,
  RETURN_ACCEPTED: OM.ReturnAcceptedOrderStatus,
  RETURN_REJECTED: OM.ReturnRejectedOrderStatus,
  RETURN_CANCELLED: OM.ReturnCancelledOrderStatus,
  PARTIALLY_RETURNED: OM.ReturnPartiallyReturnedOrderStatus,
  REFUNDED: OM.ReturnRefundedOrderStatus,
};

const getActiveStep = (status: FulfillmentStatus) => {
  switch (status) {
    case 'IN_RETURN':
      return 1;

    case 'RETURN_REGISTERED':
      return 2;

    case 'RETURN_RECEIVED':
      return 3;

    case 'RETURN_ACCEPTED':
    case 'RETURN_REJECTED':
    case 'RETURN_CANCELLED':
    case 'PARTIALLY_RETURNED':
      return 4;

    case 'REFUNDED':
      return 5;

    default:
      return 0;
  }
};

const ACCEPTED_STATUSES: FulfillmentStatus[] = [
  'IN_RETURN',
  'RETURN_REGISTERED',
  'RETURN_RECEIVED',
  'RETURN_ACCEPTED',
  'REFUNDED',
];

const REJECTED_STATUSES: FulfillmentStatus[] = [
  'IN_RETURN',
  'RETURN_REGISTERED',
  'RETURN_RECEIVED',
  'RETURN_REJECTED',
  'REFUNDED',
];

const CANCELLED_STATUSES: FulfillmentStatus[] = [
  'IN_RETURN',
  'RETURN_REGISTERED',
  'RETURN_RECEIVED',
  'RETURN_CANCELLED',
  'REFUNDED',
];

const PARTIALLY_RETURNED_STATUSES: FulfillmentStatus[] = [
  'IN_RETURN',
  'RETURN_REGISTERED',
  'RETURN_RECEIVED',
  'PARTIALLY_RETURNED',
  'REFUNDED',
];

export const ReturnOrderStatusStepper = ({
  status,
}: ReturnOrderStatusStepperProps) => {
  let statuses: FulfillmentStatus[];
  switch (status) {
    case 'RETURN_CANCELLED':
      statuses = CANCELLED_STATUSES;
      break;
    case 'RETURN_REJECTED':
      statuses = REJECTED_STATUSES;
      break;
    case 'PARTIALLY_RETURNED':
      statuses = PARTIALLY_RETURNED_STATUSES;
      break;
    default:
      statuses = ACCEPTED_STATUSES;
  }
  return (
    <StateStepper
      activeStep={getActiveStep(status)}
      data-test-id='ReturnOrderStatusStepper'
      isFullWidth
    >
      {statuses?.map((status, i) => (
        <StateStepper.Step
          key={`ReturnOrderStatusStep${i}`}
          data-test-id={`ReturnOrderStatusStepperStep-${i}`}
        >
          <StateStepper.Label
            data-test-id={`ReturnOrderStatusStepperLabel-${i}`}
          >
            {RETURN_ORDER_STATUS_MESSAGE_MAPPING[status]}
          </StateStepper.Label>
        </StateStepper.Step>
      ))}
    </StateStepper>
  );
};

ReturnOrderStatusStepper.displayName = 'ReturnOrderStatusStepper';
